import { IReport } from "../../interfaces/dto/report.dto";
import { ReportActions, IReportActionTypes } from "../actions/report.action";

export interface IReportState {
  report: {
    isLoading: boolean;
    error?: string;
    data?: Array<IReport>;
  };
}

const initialState: IReportState = {
  report: {
    isLoading: false,
  },
};

export const reportReducer = (
  state = initialState,
  action: IReportActionTypes,
): IReportState => {
  switch (action.type) {
    case ReportActions.REPORT_FETCH:
      return {
        ...state,
        report: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case ReportActions.REPORT_FETCH_SUCCESS:
      return {
        ...state,
        report: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case ReportActions.REPORT_FETCH_FAILURE:
      return {
        ...state,
        report: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    default:
      return state;
  }
};